// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1SoGO","image":"Header_image__2RQW9","name":"Header_name__dp1jy","info":"Header_info__2IZ8D","infoRow":"Header_infoRow__Iirr5"};